import { render } from "./WideLinkBlock.vue?vue&type=template&id=9a69eb80"
import script from "./WideLinkBlock.vue?vue&type=script&lang=js"
export * from "./WideLinkBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__